import styled from 'styled-components';

export const GoalContainer = styled.div`
  display: grid;
  grid-template-columns: 45px 1fr;
  padding-right: 45px;
`;
